<template>
  <footer class="footer mt-4 pt-4 my-md-5 pt-md-5 border-top">
    <div class="row">
      <div class="col-12 col-md">
        <!-- img class="mb-2" src="../assets/images/bootstrap-vue.png" alt width="24" height="24" /-->
        <small class="d-block mb-3 text-muted">&copy; Hyperactives 2020</small>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterBar'
};
</script>
